<template>
    <div class="card-block" style="position:relative; top: 75px">
      <h1>Redefinir Senha</h1>
      <p class="text-muted">Digite as informações abaixo para redifinir sua senha!</p>
      <div class="input-group mb-4">
        <span class="input-group-addon"><i class="icon-envelope"></i></span>
        <b-form-input type="text"
                id="username"
                name="username"
                :placeholder="'Digite seu nome de usuário'"
                v-model="username"
                >
        </b-form-input>
      </div>
      <div class="row">
        <div class="col-6 text-left">
          <p  style="color: #04A791" @click="handleBackToLogin" class="btn btn-link px-0"><i class="fa fa-history"></i> Voltar</p>
        </div>
        <div class="col-6 text-right">
          <button type="button" class="btn btn-third px-4" @click="onResetPassword"><i class="fa fa-check-circle"></i> Redefinir</button>
        </div>
      </div>
    </div>
</template>
<script>
import LostPassword from './LostPassword.js'

export default LostPassword

</script>



// WEBPACK FOOTER //
// src/views/public/auth/lost/LostPassword.vue